export default __webpack_public_path__ + "static/arthroscopy-b3b70554541ca204d88b197188f6d066.jpg";